import { LinkButton } from '@focaldata/cin-ui-components'
import { FC } from 'react'
import { usePackageRestrictionsDialog } from './PackageRestrictionsDialogProvider'

/** Opens the PackageRestrictionsDialog. Renders nothing outside its provider. */
const PackageRestrictionsTrigger: FC = () => {
  const dialog = usePackageRestrictionsDialog()

  if (!dialog) {
    return null
  }

  return (
    <LinkButton onClick={dialog.openPackageRestrictions} noPadding>
      Package restrictions
    </LinkButton>
  )
}

export default PackageRestrictionsTrigger
